import { activateUser as api } from "../api/index";
import { toastr } from "react-redux-toastr";
import createAction from "redux-actions/es/createAction";

export const activeUserStart = createAction("ACTIVE_USER_START");
export const activeUserCharFail = createAction("ACTIVE_USER_FAIL");
export const activeUserCharSuccess = createAction("ACTIVE_USER_SUCCESS");


export const checkUser =   (values) => {
  return  (dispatch) => {
    api(values)
    .then((res) => {
      let info={
        value:'',
        status:''
      }
      if(res.data.includes('has been activated')){
        info.value=res.data;
        info.status="sccuess";
        toastr.success("User Activation Success", res.data);
      }else if( res.data.includes('already active')){
        info.value=res.data;
        info.status="warning";
     
        toastr.info("User Activation Error", res.data);
      }else if(res.data.includes('or the Activation Code')){
        let  messagemodify=res.data.split('Activation Code');
        info.value=messagemodify[0]+" "+ 'Activation Code.' +" " ;
        info.status="error";
        toastr.error("User Activation Error", info.value);
      }else if(res.data.includes('Token already')){
        info.value=res.data;
        info.status="error";
        toastr.error("User Activation Error", res.data);
      }
      dispatch(activeUserCharSuccess(info));
    })
    .catch((err) => {
      toastr.error(
        "User Activation",
        "Houstan we have a problem!!! Please contact the adminstrator"
      );
      dispatch(activeUserCharFail(err));
 
    });
  } 
};
